import { useNavigate, useLocation } from "react-router-dom";
import { usePartnerNavigate } from "src/api/hooks/usePartnerNavigate";
import Header from "src/components/layout/Header";

// 서비스 타입 가이드라인 컴포넌트
// 유의사항 정보를 표시하는 모달 컴포넌트
const ServiceTypeGuidelines = () => {
  // 네비게이션 및 위치 정보
  const navigate = usePartnerNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // URL 파라미터에서 가이드 정보 가져오기
  const guideInfo = JSON.parse(decodeURIComponent(searchParams.get("data") || "{}"));

  // 모달 닫기 핸들러
  const onClose = () => {
    navigate(-1);
  };

  return (
    <>
      {/* 가이드 정보가 있는 경우에만 표시 */}
      {guideInfo && guideInfo.initValue !== undefined && guideInfo.initValue !== "" && (
        <>
          {/* 헤더 컴포넌트 */}
          <Header
            headerType="BACK"
            title="유의사항"
            onClickBackButton={() => {
              onClose()!;
            }}
          />

          {/* 유의사항 섹션 */}
          <section className="base-section-layout w-100">
            <div className="base-section-layout__container">
              <div className="base-section-layout__wrap">
                {/* 섹션 제목 */}
                <div className="base-section-layout__title-wrap">
                  <h2>{"유의사항"}</h2>
                </div>

                {/* 유의사항 내용 표시 */}
                <div>
                  <div>
                    {guideInfo.initValue.split("\n").map((line: any, idx: number) => {
                      return (
                        <span key={idx}>
                          <p className="font14">{line}</p>
                        </span>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default ServiceTypeGuidelines;
